import React, { useState } from "react";
import { InternationalDatepicker } from "../InternationalDatepicker";

interface IColumnFilterTemplateProps {
  showButtonBar?: boolean;
  onChange: (event: any) => void;
  placeholder?: string;
}

export function DateFilterTemplate(props: IColumnFilterTemplateProps) {
  const [selectedDate, setSelectedDate] = useState<Date | undefined>(undefined);

  function onChange(event: any) {
    setSelectedDate(event.target.value);
    props.onChange(event);
  }

  return (
    <InternationalDatepicker
      value={selectedDate}
      dateFormat="yy-mm-dd"
      onChange={onChange}
      className="p-column-filter"
      placeholder={props.placeholder}
      showButtonBar={props.showButtonBar}
    />
  );
}
